export class DentalProblemModel {
    problem_index: number
    problem_name: string

    constructor(
        problem_index: number,
        problem_name: string
    ) {
        this.problem_index = problem_index
        this.problem_name = problem_name
    }
}